// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'
import formatSite from '../formatSite'
import getBackToBackData from './getBackToBackData'
import splitPassiveRepeaterAntennaIntoSegmentEndAntenna from './splitPassiveRepeaterAntennaIntoSegmentEndAntenna'

const splitPassiveRepeaterIntoSegmentEnds = passiveRepeater => {
  // then we iterate through the returned array of polished passive repeaters
  // adding them to the segments array as segmentEnds

  // both segment end ids are stored on the single passive repeater. Then when prepping the data for the API,
  // we split passive repeater into two separate segment ends.
  const p1SegmentEndId = passiveRepeater.site.segmentEndId
  const p2SegmentEndId = passiveRepeater.site.secondSegmentEndId

  // since formatSite is based on Site1/Site2 and not passive repeaters, it does not worry about ASR, Call Sign and segmentStatusId
  // (ASR/Call Sign are in the 'regulatory' section for Site1/Site2 and in Passive Repeaters it's at the 'site' level.)
  const asr = castToFloat(passiveRepeater.site.asr)
  const callSign = passiveRepeater.site.callSign
  const segmentStatusId = castToFloat(passiveRepeater.site.segmentStatusId)

  // prep backToBack data for API - reduce because backToBack
  // is an array that will have 0 or 1 b2b objects.
  // this is an array so that when toggling b2b, we can
  // reuse redux-forms reducer to toggle the set.
  const backToBack = getBackToBackData(passiveRepeater.backToBack)

  const {
    p1Antenna,
    p2Antenna,
  } = splitPassiveRepeaterAntennaIntoSegmentEndAntenna(passiveRepeater.antennas)

  const passiveSiteBasis = {
    ...formatSite(passiveRepeater.site),
    ...backToBack,
    asr,
    callSign,
    passiveFlag: true,
    segmentStatusId,
  }

  const p1SegmentEnd = {
    ...passiveSiteBasis,
    segmentEndId: p1SegmentEndId,
    antennas: p1Antenna,
  }

  const p2SegmentEnd = {
    ...passiveSiteBasis,
    segmentEndId: p2SegmentEndId,
    // if this passive repeater is a billboard, p2Ant will be undefined.
    // just assign the exact same values to this segmentEnd as its counterpart
    // in the previous segment array.
    antennas: p2Antenna,
  }

  return {
    p1SegmentEnd,
    p2SegmentEnd,
  }
}

export default splitPassiveRepeaterIntoSegmentEnds
